import React from '../services/React';
import UI from '../services/UI';

class PanelTabs extends React.Component {
  setActiveTab(idx) {
    this.panelTabsCmp.setActiveTab(idx);
  }

  componentDidMount() {
    this.setActiveTab(this.props.activeTabIndex);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeTabIndex !== this.props.activeTabIndex) {
      this.setActiveTab(nextProps.activeTabIndex);
    }
  }

  render() {
    return (
      <UI.panelTabs
        {...this.props}
        ref={input => {
          this.panelTabsCmp = input;
        }}
      />
    );
  }
}

export default PanelTabs;



// WEBPACK FOOTER //
// ./src/commons/components/PanelTabs.jsx